/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */

'use es6';

import FeedbackNumberRating from './internal/FeedbackNumberRating';
import { jsx as _jsx } from "react/jsx-runtime";
export default (props => /*#__PURE__*/_jsx(FeedbackNumberRating, Object.assign({
  "data-selenium-test": "feedback-rating-nps",
  min: 0,
  max: 10,
  name: "nps-rating"
}, props)));